import domReady from '@wordpress/dom-ready';

domReady(() => {
  const button = document.querySelector('#join-us');
  const footer = document.querySelector('.site-footer');
  const offset = 200;
  let timer = null;

  if (button) {
    function checkButtonVisibility() {
      if (footer.getBoundingClientRect().top < button.offsetTop + offset) {
        button.classList.remove('visible');
      } else {
        button.classList.add('visible');
      }
    }

    window.addEventListener('scroll', () => {
      if (timer) {
        window.clearTimeout(timer);
      }

      timer = window.setTimeout(function () {
        // actual callback
        checkButtonVisibility();
      }, 50);
    });

    checkButtonVisibility();
  }
});
